<div class="content p-24">

    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="h2 mb-24">{{'Device data'|translate}}</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Name'|translate}}</mat-label>
                    <input matInput formControlName="name" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>{{'Name is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Serial number'|translate}}</mat-label>
                    <input matInput formControlName="serialNumber" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>{{'Serial number is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Description'|translate}}</mat-label>
                    <textarea matInput formControlName="description"></textarea>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="active" fxFlex="100">
                    <mat-label>{{'Active'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="registered" fxFlex="100">
                    <mat-label>{{'Registered'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Device group'|translate}}</mat-label>
                    <mat-select formControlName="deviceGroup">
                        <mat-option [value]="deviceGroup.id" *ngFor="let deviceGroup of deviceGroups">
                            {{deviceGroup.name}}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button type="submit" color="accent">
                        {{'Save'|translate}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
